export const actions = {
  nuxtServerInit ({ commit }) {
    const saleUntil = Date.UTC(2024, 1, 22, 21) // 2024-02-23T00:00+03:00
    commit("app/SET_SALE", Date.now() < saleUntil)
  },
}
